module.exports = __webpack_public_path__ + "img/honor1.c434d917.png";